import { Link } from "react-router-dom";

const featured = [
  {
    image: "https://public.readdy.ai/ai/img_res/448186a3dab04087ec1bb4617c132f52.jpg",
    title: "Aluminium Bifold Doors",
    tag: "Best Seller",
  },
  {
    image: "https://readdy.ai/api/search-image?query=modern%20conservatory%20extension%20uk%20home%20interior%20bright%20comfortable%20living%20space%20glass%20roof%20plants&width=600&height=400&seq=feat2&orientation=landscape",
    title: "Conservatories",
    tag: "Popular",
  },
  {
    image: "https://readdy.ai/api/search-image?query=elegant%20roof%20lantern%20kitchen%20extension%20natural%20light%20flooding%20modern%20uk%20home%20aluminium%20glass%20architectural&width=600&height=400&seq=feat3&orientation=landscape",
    title: "Roof Lanterns",
    tag: "Featured",
  },
];

export default function FeaturedWork() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div>
            <span
              className="text-amber-600 text-xs font-bold tracking-widest uppercase"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              Our Work
            </span>
            <h2
              className="text-4xl lg:text-5xl font-bold text-zinc-900 mt-3"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Featured Installations
            </h2>
          </div>
          <Link
            to="/gallery"
            className="flex items-center gap-2 text-amber-600 font-semibold text-sm hover:gap-3 transition-all whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Raleway', sans-serif" }}
          >
            View Full Gallery
            <div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></div>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featured.map((item) => (
            <Link key={item.title} to="/gallery" className="group relative rounded-lg overflow-hidden cursor-pointer block">
              <div className="w-full h-72">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute top-4 left-4">
                <span
                  className="bg-amber-600 text-white text-xs font-bold px-3 py-1 rounded-full"
                  style={{ fontFamily: "'Raleway', sans-serif" }}
                >
                  {item.tag}
                </span>
              </div>
              <div className="absolute bottom-5 left-5">
                <h3
                  className="text-white text-xl font-bold"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {item.title}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
